// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__tlQUp","linkContainer":"Footer_linkContainer__45gPC"};